/**
 * PasswordLogin — web (non-LINE) sign-in for Owner/HR. Shown when there's no
 * LIFF context (status 'no-liff'). On success the auth store flips to 'ok' and
 * the app re-renders into the shell.
 */
import { useState } from 'react';
import { LogIn } from 'lucide-react';
import { loginWithPassword } from '../hooks/useAuth';
import { ApiError } from '../lib/api-client';
import { Logo } from '../components/ui/Logo';

export function PasswordLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await loginWithPassword(email.trim(), password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
      <section className="card w-full max-w-sm p-7 space-y-5">
        <div className="flex flex-col items-center text-center gap-2">
          <Logo />
          <div>
            <h1 className="font-display text-xl font-semibold">
              Eval <span className="grad-text">Pilot</span>
            </h1>
            <p className="text-sm text-gray-500">เข้าสู่ระบบสำหรับ Owner / HR</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="label" htmlFor="email">
              อีเมล
            </label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="label" htmlFor="password">
              รหัสผ่าน
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}

          <button type="submit" className="btn-cta w-full" disabled={busy}>
            <LogIn className="w-4 h-4" />
            {busy ? 'กำลังเข้าสู่ระบบ…' : 'เข้าสู่ระบบ'}
          </button>
        </form>

        <p className="text-xs text-gray-400 text-center">
          พนักงานทั่วไปเข้าผ่าน LINE — เปิดจากเมนู LINE ขององค์กร
        </p>
      </section>
    </main>
  );
}
